'use strict';

var FilterSelectWizardView = require('components/devices/views/common/filter_select_wizard_view');
var I18N = require('utils/i18n');
var Misc = require('utils/misc');
var OOP = require('utils/oop');

var GroupView = OOP.extend(
    FilterSelectWizardView,
    {
        template: require('components/devices/templates/groups/group'),
        initialize: function (options) {
            var optData = options.data || {};
            this.base.initialize(options);
            this.data = {
                name: optData.name,
                forAll: optData.forAll,
            };

            var selection = (optData.filter || {}).selection;

            this.errors = {};
            this.filterIntf = this.installFilter(
                {
                    filter: Misc.cloneAsJSON(optData.filter),
                    selection: selection,
                },
                { noGroups: true }
            );
            this.cb = options.cb;
        },

        saveGroupData: function () {
            this.data.name = this.ui.edtName.val();
            this.updateWizardButtons();
        },

        serializeData: function () {
            var data = this.base.serializeData();
            data.data = this.data;
            data.errors = this.errors;
            return data;
        },

        ui: OOP.inheritedObj('ui', {
            edtName: 'input#name-edt',
        }),

        events: OOP.inheritedObj('events', {
            'change input#name-edt': 'saveGroupData',
            'keyup  input#name-edt': 'saveGroupData',
        }),

        setError: function (errorData) {
            this.base.setError(errorData);
            this.changePage(this.selected, true);
        },

        initControls: function () {
            Misc.initSelectPicker({ class: 'form-control' });
        },

        onRender: function () {
            this.initControls();
        },

        getTabNames: OOP.inheritedObj('getTabNames', {
            Group: I18N.TR('Gruppe'),
        }),

        getGroupPageIdx: function () {
            return this.filterConfig.selectionTab + 1;
        },

        wizardDone: function () {
            var self = this;
            var isValid = this.wizardValidate(function (frm) {
                this.required('name', frm.data.name, I18N.TR('Der Name muss angegeben werden.'), frm.ui.edtName, {
                    page: self.getGroupPageIdx(),
                });

                this.maxLen(
                    'name',
                    frm.data.name,
                    100,
                    I18N.TR('Der Name darf nicht länger als 100 Zeichen sein.'),
                    frm.ui.edtName,
                    { page: self.getGroupPageIdx() }
                );
            });
            if (isValid && this.cb) {
                this.setError(undefined);
                this.data.filter = this.filterIntf.filter;
                this.cb(this.data);
            }
        },

        canWizardFinish: function () {
            var hasName = this.data.name != undefined && this.data.name.length > 0;

            if (!this.base.canWizardFinish()) return false;

            return hasName;
        },
    },
    'GroupView'
);

module.exports = GroupView;
